import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=1a30d972&scoped=true&"
import script from "./GoogleButton.vue?vue&type=script&lang=js&"
export * from "./GoogleButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleButton.vue?vue&type=style&index=0&id=1a30d972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30d972",
  null
  
)

export default component.exports